// components/common/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
    const { user, loading } = useAuth();

/*    console.log('ProtectedRoute:', { 
      user, 
      loading, 
      requireAdmin,
      hasUser: !!user 
    });
 */
    if (loading) {
        /// console.log('ProtectedRoute: Loading...');
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600"></div>
            </div>
        );
    }

    if (!user) {
        /// console.log('ProtectedRoute: No user, redirecting to login');
        return <Navigate to="/security" replace />;
    }

/*  // Si requireAdmin es true, pero el usuario no tiene role o no es admin
    if (requireAdmin && (!user.role || user.role !== 'admin')) {
        // Puedes redirigir a una página de "acceso denegado" o al dashboard
        return <Navigate to="/admin/dashboard" replace />;
    } */

    /// console.log('ProtectedRoute: Rendering children');
    return children;
};

export default ProtectedRoute;